import { createSlice,PayloadAction} from '@reduxjs/toolkit';


interface State {
    reviwerEmail:string;
    reviwerName:string;
    reviwerPosition:string;
    reviwerPicture:string;
    videoStop:boolean;

    video:string;
    videoId:string;
    recommendationId:string;

    recommendationType:string;

    buttonPress:boolean;

  }
  
  const initialState: State = {
    reviwerEmail:"",
    reviwerName:"",
    reviwerPosition:"",
    reviwerPicture:"",
    videoStop:false,

    video:"",
    videoId:"",
    recommendationId:"",

    recommendationType:"video",

    buttonPress:false,

  };


  const recommendFlowSlice = createSlice({
    name: 'recommendFlow',
    initialState,
    reducers: {
         setReviwerEmail(state, action: PayloadAction<string>) {
            state.reviwerEmail = action.payload;
          },

          setReviwerName(state, action: PayloadAction<string>) {
            state.reviwerName = action.payload;
          },

          setReviwerPosition(state, action: PayloadAction<string>) {
            state.reviwerPosition = action.payload;
          },

          setReviwerPicture(state, action: PayloadAction<string>) {
            state.reviwerPicture = action.payload;
          },

          setVideoStopStatus(state, action: PayloadAction<boolean>) {
            state.videoStop = action.payload; 
          },


          setVideo(state, action: PayloadAction<string>) {
            state.video = action.payload; 
          },
          setVideoId(state, action: PayloadAction<string>) {
            state.videoId = action.payload; 
          },
          setRecommendationID(state, action: PayloadAction<string>) {
            state.recommendationId = action.payload; 
          },

          setButtonPress(state) {
            state.buttonPress = !state.buttonPress;
          },

          setRecommendationType(state, action: PayloadAction<string>) {
            state.recommendationType = action.payload; 
          },

    },

    // extraReducers: (builder) => {
    //   builder
    // },
  });
  

  export const {
    setReviwerEmail,
    setReviwerName,
    setReviwerPosition,
    setReviwerPicture,
    setVideoStopStatus,

    setVideoId,
    setVideo,
    setRecommendationID,

    setRecommendationType,

    setButtonPress
    
  } = recommendFlowSlice.actions;

  export default recommendFlowSlice.reducer;